import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { ModalState } from '../../_stores/modal/_state/modal.state';
import { ModalCloseAction } from '../../_stores/modal/_actions/modal.actions';
import { DeleteVideo } from '../../_stores/videos/_actions/videos.actions';

@Component({
  selector: 'ui-control-question-delete',
  templateUrl: './ui-control-question-delete.component.html',
  styleUrls: ['./ui-control-question-delete.component.scss'],
})
export class UiControlQuestionDeleteComponent implements OnInit {
  interface = {
    _id: '',
    loading: false,
  };

  constructor(private store: Store, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.store.select(ModalState.selectOpenedID).subscribe((_openedID) => {
      this.interface._id = _openedID;
      this.cdr.detectChanges();
    });
  }

  videoDelete() {
    this.interface.loading = true;
    this.store.dispatch(new DeleteVideo({ videoID: this.interface._id })).subscribe({
      next: () => {
        this.store.dispatch(new ModalCloseAction());
        this.interface.loading = false;
        this.cdr.detectChanges();
      },
    });
    this.cdr.detectChanges();
  }

  actionClose() {
    this.store.dispatch(new ModalCloseAction());
  }
}
